module.exports = __webpack_public_path__ + "img/icon-sprite.3ae36f6c.png";